module.exports = __webpack_public_path__ + "img/body-1.0ddea9fb.png";